import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProductUpSale } from "Components/Ecom/Product/UpSale/Models";
import UpSaleService from "./UpSaleService";

@Component({
    template: '#product-upsale-icon-template',
})
export default class UpSaleIconComponent extends Vue {

    @Prop()
    private translation: string;

    @Prop()
    private quantityDifferenceForNextDiscount: number;
    @Prop()
    private quantityDifferenceForNextUnitType: number;
    @Prop()
    private quantityInCurrentUnit: number;
    @Prop()
    private differenceInPercentageForNextDiscount: number;

    @Prop()
    private refCounter: string;

    public disableBtn = false;
    private quantityInDifference = 0;
    private differenceInPercentage = 0;

    private input: any = <any>{};

    created() {
        var self = this;
        //listen on parent events
        this.$parent.$on('quanity-changed', (value: any) => {
            if (this.refCounter != value.key) return;

            self.quantityInDifference = self.quantityDifferenceForNextUnitType - value.quantity;
            ////100 - (12.500 / 600.000 * 100) = (100-2) = 98 % in difference to discount of next unit type.
            self.differenceInPercentage =
                100 - (value.quantity / self.quantityDifferenceForNextUnitType * 100);
        });
    }

    mounted() {
        this.quantityInDifference = this.quantityDifferenceForNextDiscount;
        this.differenceInPercentage = this.differenceInPercentageForNextDiscount;
    }



    public get show() {
        return UpSaleService.isUpSale(this.quantityInDifference, this.differenceInPercentage);
    }

    autoAdd() {
        if (this.disableBtn) return; //do not trigger - safe guard
        this.disableBtn = true;
        this.$emit('updatequanity:value', this.refCounter, this.quantityDifferenceForNextUnitType);
        this.quantityInDifference = 0;
    }
}
Vue.component('product-upsale-icon', UpSaleIconComponent);